<template>
    <transition name="modal-fade">
        <div class="modal modal-mask" style="display: block">
            <div class="modal-dialog modal-dialog-centered">
                <div class="modal-content">
                    <template>
                        <div class="modal-header">
                            <h5 class="modal-title">Disconnected From Database</h5>
                            <button type="button" class="close" v-on:click="$emit('close')">&times;</button>
                        </div>
                        <div class="modal-body">
                            There seems to be a problem with your connection to the database. Your last {{ connectData }} changes to the model haven't been able to autosave.<br><br>
                            You can try manually saving again or refreshing the page to reload your database connection.
                        </div>
                        <div class="modal-footer">
                            <button type="button" class="btn btn-secondary" @click="closeModal">{{ lang['button.cancel'] }}</button>
                            <button type="button" class="btn btn-primary btn-gradient" @click="attemptSave">Attempt Save</button>
                            <button type="button" class="btn btn-delete" @click="reloadPage">Refresh Page</button>
                        </div>
                    </template>
                </div>
            </div>
        </div>
    </transition>


</template>

<script>
    export default {
        props: ['connectData'],

        data() {
            return {
                lang: lang,
            }
        },

        methods: {

            closeModal() {
                this.$emit('close');
            },

            attemptSave() {
                this.closeModal();
                pushTree(true);
            },

            reloadPage() {
                this.closeModal();
                location.reload();
            },

        }
    }
</script>
